// Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
// Services
import { SessionService } from '../services/SessionService';
import { AdminService } from '../services/AdminService';
// Models
import { Admin } from '../models/Admin';
import { AdminCredential } from '../models/AdminCredential';

@Component({
    selector: 'admin-login',
    template: require('./LoginComponent.html'),
    styles: [require('./LoginComponent.sass')]
})

export class LoginComponent implements OnInit {
    adminCredential:     AdminCredential;
    message:        string;
    messageType:    string;
    redirectUrl:    string;
    formSubmitted: boolean = false;
    adminData: Admin;
    environment: string;
    sidebarStatus: boolean;
	private hostName: string;
    
    constructor(
        private sessionService: SessionService,
        private adminService: AdminService,
        private router: Router
    ) {
        this.adminCredential = new AdminCredential('','','');
    }

    ngOnInit() {
        this.deleteSession();
        this.redirectUrl = '/navigate';
		this.hostName = window.location.hostname;
        // Use Session Service to get session and check if user had already logged in.
        this.getSession();
    };

    onSubmit() {
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post admin login data to create session
        this.postSession(this.adminCredential);
    }

    private getSession() : void{
        this.sessionService.getSession()
            .subscribe(
                admin => {
                    // Set admin session data
                    this.adminService.setAdminSessionData(admin);
                    // Fire admin session data changed event
                    this.adminService.adminDataChanged(admin);
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }
    
    /**
     * Post Session to API service to create new session.
     * Update admin Data on local storage and redirect to desired URL
     * if request responses session data.
     * @param {Credential} - admin credential input
     * @return none
     */
    private postSession(adminCredential: AdminCredential) {
        this.sessionService.postAdminSession(adminCredential)
            .subscribe(
                admin => {
                    this.adminService.setAdminSessionData(admin);
                    this.adminService.adminDataChanged(admin);
                    // Redirect to nagigate center
                    this.redirect('/navigate')
                },
                error   => {
                    this.formSubmitted = false;
                    this.message = "Invalid user name or password.";
                    this.messageType = "alert";
                }
            );
    }

    // Redirect to desired url
    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]); 
    }
    
    private deleteSession() {
        this.sessionService.deleteAdminSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.adminService.clearAdminSessionData();
                    this.adminService.clearInterSession();
                    this.adminService.adminDataChanged(null);
                },
            );
    }
}



// WEBPACK FOOTER //
// ./src/common/modules/admin/login/LoginComponent.ts